// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionHeader_title__e9gnz"};